/* Zorina Mast — dodaci za Zipify 1:1 raspored */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-zm-bundle-input]');
    if (!input) return;
    var root = input.closest('[data-zm-bundle-root]');
    if (!root) return;
    root.querySelectorAll('[data-zm-offer]').forEach(function (o) {
      o.classList.toggle('is-active', o.dataset.zmOffer === input.value);
    });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#zm-"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zm-gal-nav]');
    if (!b) return;
    var g = b.closest('[data-zm-gallery]');
    if (!g) return;
    var th = Array.prototype.slice.call(g.querySelectorAll('[data-zm-thumb]'));
    if (!th.length) return;
    var i = th.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
    if (i < 0) i = 0;
    i = (i + (b.dataset.zmGalNav === 'next' ? 1 : -1) + th.length) % th.length;
    th[i].click();
  });

  /* klizač preporuka (mobitel) */
  function initRel(root) {
    if (root.dataset.zmRelInit) return;
    var grid = root.querySelector('.zm-rel__grid');
    var dots = root.querySelector('.zm-rel__dots');
    if (!grid || !dots) return;
    root.dataset.zmRelInit = '1';
    function pages() { return Math.max(1, Math.round(grid.scrollWidth / grid.clientWidth)); }
    function build() {
      var n = pages();
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Stranica ' + (i + 1));
        d.dataset.i = i;
        dots.appendChild(d);
      }
      mark();
    }
    function mark() {
      var i = Math.round(grid.scrollLeft / grid.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    grid.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    dots.addEventListener('click', function (e) {
      var d = e.target.closest('button');
      if (d) grid.scrollTo({ left: d.dataset.i * grid.clientWidth, behavior: 'smooth' });
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zm-rel-nav]');
      if (!b) return;
      var dir = b.dataset.zmRelNav === 'next' ? 1 : -1;
      var max = grid.scrollWidth - grid.clientWidth;
      var to = grid.scrollLeft + dir * grid.clientWidth;
      if (to > max + 2) to = 0;
      if (to < -2) to = max;
      grid.scrollTo({ left: to, behavior: 'smooth' });
    });
    window.addEventListener('resize', build);
    build();
  }
  function scanRel() { document.querySelectorAll('[data-zm-rel]').forEach(initRel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanRel); else scanRel();
  new MutationObserver(scanRel).observe(document.documentElement, { childList: true, subtree: true });
})();
